import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/productsActions';
import BrowseFilter from './BrowseFilter';
import ProductsList from './ProductsList';
import {formatNumber} from '../utils/number';
import {attemptAddToCart} from '../utils/orderHandling';
import base64url from 'base64url';

const filterNames = [
  'categories',
  'colors',
  'conditions',
  'pageYields',
  'mlVolumes',
  'lVolumes',
  'staplesYields',
  'photosYields',
  'packAmounts',
  'sizes',
  'isPreviouslyPurchasedOnly',
];

const filterGroups = {
  ink: ['colors', 'conditions', 'manufacturers', 'pageYields', 'lVolumes', 'mlVolumes'],
  drums: ['colors', 'conditions', 'manufacturers'],
  filaments: ['colors', 'conditions', 'manufacturers'],
  micr: ['conditions', 'manufacturers', 'pageYields'],
  fusers: ['conditions', 'manufacturers'],
  maintenance: ['conditions', 'manufacturers'],
  parts: ['subcategories'],
  staples: ['staplesYields'],
};

let filterChangeTimeout;

class AppProducts extends Component {
  constructor(props) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.fetchProducts = this.fetchProducts.bind(this);
    this.fetchFilters = this.fetchFilters.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.handleAddPrinter = this.handleAddPrinter.bind(this);
    this.handleRemovePrinter = this.handleRemovePrinter.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleAddToMyProducts = this.handleAddToMyProducts.bind(this);
    this.handleRemoveFromMyProducts = this.handleRemoveFromMyProducts.bind(this);
    this.handlePerPageChange = this.handlePerPageChange.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleQtyChange = this.handleQtyChange.bind(this);
    this.handleAddToCart = this.handleAddToCart.bind(this);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.processHash = this.processHash.bind(this);
    this.updateHash = this.updateHash.bind(this);
    this.hashToState = this.hashToState.bind(this);
    this.handleEmailLinkClick = this.handleEmailLinkClick.bind(this);

    window.state = this.state = this.getStateFromHash();
  }

  getStateFromHash() {
    const hash = document.location.hash.replace(/^#\//, ''),
      hashedState = this.hashToState(hash);

    return {
      sort: hashedState.sort || 'relevance',
      page: hashedState.page || 0,
      perPage: hashedState.perPage || 20,
      searchTerm: hashedState.searchTerm || this.props.searchTerms || '',
      quantities: {},

      filters: Object.assign(this.getDefaultFilters(), hashedState.filters),
      newFilters: Object.assign(this.getDefaultFilters(), hashedState.filters)
    };
  }

  processHash() {
    this.setState(this.getStateFromHash(), this.fetchProducts);
  }

  getDefaultFilters() {
    const filters = {};

    Object.keys(filterGroups).map(category => {
      filters[category] = {};
      filterGroups[category].map(filter => {
        filters[category][filter] = [];
      });
    });

    return filters;
  }

  stateToHash() {
    const filters = {};
    let hash = [];

    if (this.state.page) {
      hash.push(`page=${this.state.page}`);
    }
    if (this.state.sort) {
      hash.push(`sort=${this.state.sort}`);
    }
    if (this.state.perPage) {
      hash.push(`perPage=${this.state.perPage}`);
    }

    if (!this.props.searchTerms && this.state.searchTerm !== '') {
      hash.push(`searchTerm=${this.state.searchTerm}`);
    }

    // clean filters data
    Object.keys(this.state.filters).map(group => {
      if (group != '_') {
        const filterGroup = {};
        Object.keys(this.state.filters[group]).map(filter => {
          if (this.state.filters[group][filter].length) {
            filterGroup[filter] = this.state.filters[group][filter];
          }
        });
        if (Object.keys(filterGroup).length) {
          filters[group] = filterGroup;
        }
      } else if (this.state.filters._.isPreviouslyPurchasedOnly.includes('1')) {
        filters.isPreviouslyPurchasedOnly = true;
      }
    });

    hash.push(`filters=${base64url(JSON.stringify(filters))}`);

    return hash.join('&');
  }

  hashToState(hash) {
    let state = {
      filters: {}
    };
    hash.split('&').map(param => {
      if (param.indexOf('=') > -1) {
        const [key, value] = param.split('=');
        if (key !== '') {
          if (key === 'page') {
            state.page = parseInt(value);
          } else if (key === 'searchTerm') {
            state.searchTerm = decodeURIComponent(value);
          } else if (key === 'sort') {
            state.sort = value;
          } else if (key === 'perPage') {
            state.perPage = value;
          } else {
            state.filters = JSON.parse(base64url.decode(value));
          }
        }
      }
    });

    return state;
  }

  resetFilters() {
    return new Promise(resolve => {
      this.setState({
        filters: this.getDefaultFilters()
      }, resolve);
    });
  }

  handleBackButton() {
    if (this.isNonBackButtonEvent) {
      this.isNonBackButtonEvent = false;
      return;
    }

    this.processHash();
  }

  componentDidMount() {
    this.fetchFilters();

    window.addEventListener('hashchange', this.handleBackButton, false);
  }

  componentWillUnmount() {
    super.componentWillUnmount();

    // unbind back button listener
    window.removeEventListener('hashchange', this.handleBackButton, false);
  }

  fetchProducts() {
    this.updateHash();

    // clear quantities
    this.setState({ quantities: {} });

    const filters = {};

    // clean filters data
    Object.keys(this.state.filters).map(group => {
      if (group != '_') {
        const filterGroup = {};
        Object.keys(this.state.filters[group]).map(filter => {
          if (this.state.filters[group][filter].length) {
            filterGroup[filter] = this.state.filters[group][filter];
          }
        });
        if (Object.keys(filterGroup).length) {
          filters[group] = filterGroup;
        }
      } else if (this.state.filters._.isPreviouslyPurchasedOnly.includes('1')) {
        filters.isPreviouslyPurchasedOnly = true;
      }
    });

    const params = Object.assign(
      {
        isGrouped: true,
        catId: this.props.catId,
        subCatId: this.props.subCatId,
        brandId: this.props.brandId,
        filter: this.props.filter,
        prefer: this.props.prefer,
        offset: Math.ceil(this.state.page * this.state.perPage),
        perPage: this.state.perPage,
        searchTerm: this.state.searchTerm,
        sort: this.state.sort,
        isNonOemFirst: this.props.isNonOemFirst ? 1 : 0,
      },
      filters
    );

    clearTimeout(filterChangeTimeout);
    filterChangeTimeout = setTimeout(() => this.props.actions.fetchProducts(params), 50);
  }

  fetchFilters() {
    const params = {
      catId: this.props.catId,
      subCatId: this.props.subCatId,
      brandId: this.props.brandId,
      filter: this.props.filter,
      isGrouped: true,
    };

    this.props.actions.fetchFilters(params)
      .then(this.fetchProducts);
  }

  updateHash() {
    document.location.hash = '/' + this.stateToHash();
  }

  handleFilterChange(isOn, categoryId, filterId, filterValues) {
    // create new filters state object
    const filters = Object.assign({}, this.state.filters);

    filterValues.split('|').map(filterValue => {
      if (!filters.hasOwnProperty(categoryId)) {
        filters[categoryId] = {};
      }
      if (!filters[categoryId].hasOwnProperty(filterId)) {
        filters[categoryId][filterId] = [];
      }

      const filter = filters[categoryId][filterId];

      const index = filter.indexOf(filterValue);
      if (isOn) {
        if (index === -1) {
          filter.push(filterValue);
        }
      } else {
        if (index > -1) {
          filter.splice(index, 1);
        }
      }
    });

    // update filter state
    this.isNonBackButtonEvent = true;

    clearTimeout(filterChangeTimeout);
    this.setState({ page:0, filters }, () => {
        this.fetchProducts();

        // scroll to top
        window.scrollTo(0, 0);
      });
  }

  handlePageChange(page) {
    this.isNonBackButtonEvent = true;
    this.setState({ page }, this.fetchProducts);

    // scroll to top
    window.scrollTo(0, 0);
  }

  handleSearch(e) {
    this.isNonBackButtonEvent = true;
    e.preventDefault();

    const searchTerm = this.refs.searchInput.value.trim();
    this.setState({ page: 0, searchTerm }, this.fetchProducts);
  }

  resetSearch(e) {
    this.refs.searchInput.value = '';
    this.handleSearch(e);
  }

  handleAddPrinter(e) {
    const printer = this.props.printer;
    this.props.actions.addSavedPrinter(printer.id, printer.name, printer.brandId);
  }

  handleRemovePrinter(e) {
    const printer = this.props.printer;
    this.props.actions.removeSavedPrinter(printer.id);
  }

  handleSort(e) {
    this.isNonBackButtonEvent = true;

    const sort = e.target.value;
    this.setState({ sort, page: 0 }, () => this.fetchProducts());
  }

  handleAddToMyProducts(id) {
    this.props.actions.addToMyProducts(id);
  }

  handleRemoveFromMyProducts(id) {
    this.props.actions.removeFromMyProducts(id);
  }

  handlePerPageChange(e) {
    this.isNonBackButtonEvent = true;

    const perPage = e.target.value;
    this.setState({ page: 0, perPage }, () => this.fetchProducts());
  }

  handleReset(e) {
    this.resetFilters().then(this.fetchProducts);
  }

  handleHelpClick(e) {
    e.preventDefault();

    const newWindow = window.open('https://vm.providesupport.com/1kappo8yun7vt0dgu51cbtr0x4',
      'Chat',
      'toolbar=0,scrollbars=1,location=0,statusbar=0,menubar=0,resizable=1,width=640,height=480');
    newWindow.focus();
    newWindow.opener = window;
  }

  handleEmailLinkClick(e) {
    e.preventDefault();

    window.isNavigating = false;
    window.location.href = 'mailto:info@sundatasupply.com';
  }

  handleQtyChange(product, qty) {
    return new Promise(resolve => {
      const quantities = Object.assign({}, this.state.quantities);
      if (qty) {
        quantities[product.id] = Object.assign(product, { qty: parseInt(qty) });
      } else {
        delete quantities[product.id];
      }

      this.setState({ quantities }, resolve);
    });
  }

  handleAddToCart() {
    let items = {};

    Object.keys(this.state.quantities).map(id => {
      const product = this.state.quantities[id];
      if (product.qty) {
        items[product.id] = product;
      }
    });

    attemptAddToCart(Object.values(items)).then(() => {
      // clear qty selections
      this.setState({ quantities: {} });
    });
  }

  componentDidUpdate() {
    if (this.props.isFetchingFilters) return;

    /*
    // clear filter values when those filters are not visible
    filterNames.map(filterName => {

      if (!Object.keys(this.props.filters).includes(filterName) && this.state.filters[filterName].length) {
        this.setState({
          filters: Object.assign({}, this.state.filters, { [filterName]: [] })
        });
      } else if (this.state.filters[filterName] && this.props.filters[filterName]) {
        let newFiltersState = Object.assign({}, this.state.filters),
          isModified = false;

        // check for non-existent filter values
        this.state.filters[filterName].map(filterVal => {
          if (!Object.keys(this.props.filters[filterName]).includes(filterVal)) {
            isModified = true;
            newFiltersState[filterName] = newFiltersState[filterName].filter(val => filterVal != val);
          }
        });

        // update state if the filters have been modified
        if (isModified) {
          this.setState({
            filters: newFiltersState
          });
        }
      }
    });
    */
  }

  render() {

    const products = this.props.products,
      printer = this.props.printer,
      filters = this.props.filters,
      filterValues = this.state.filters;

    const totalFilters = filters && filters.groups && Object.keys(filters.groups).length || 0;

    return (
      <div className="search-results">
              <div>
                <div className="search-results__header">
                  {
                    printer
                      ?
                      <div className="row">
                        <div className="column small-3 medium-2">
                          {
                            printer.image &&
                            <img src={`${ROOT_URL}/uploads/cat/${printer.image}`}/>
                          }
                        </div>
                        <div className="column small-9 medium-5">
                          {
                            printer.name &&
                            <div>
                              <h1>{this.props.titleOverride || printer.name}</h1>
                              {
                                printer.isSaved > -1 && (
                                  printer.isSaved
                                    ? <a onClick={this.handleRemovePrinter} className="button -gray small">Remove from Your Printers List</a>
                                    : <a onClick={this.handleAddPrinter} className="button -gray small">Add to Your Printers List</a>
                                )
                              }
                            </div>
                          }
                        </div>
                        <div className="column small-12 medium-5">
                          <form onSubmit={this.handleSearch} className="input-group">
                            <input type="text" className="input-group-field" placeholder={`Search only supplies for ${this.props.titleOverride || printer.name}`}
                                   ref="searchInput" defaultValue={this.state.searchTerm}/>
                            <div className="input-group-button">
                              <button className="button -gray small">Search Products</button>
                            </div>
                          </form>

                          {
                            this.state.searchTerm !== '' &&
                            <p><a className="link__clear-search" onClick={this.resetSearch}>Clear search results</a></p>
                          }

                          <div className="row">
                            <div className="column large-6">
                              <div className="input-group search-results__header__per-page">
                                <span className="input-group-label">Display</span>
                                <select className="input-group-field" onChange={this.handlePerPageChange} value={this.state.perPage}>
                                  <option value="10">10 per page</option>
                                  <option value="20">20 per page</option>
                                  <option value="50">50 per page</option>
                                  <option value="1000">All</option>
                                </select>
                              </div>
                            </div>

                            <div className="column large-6">
                              <button className="button primary small products__button-add-all -top"
                                      disabled={!Object.keys(this.state.quantities).length}
                                      onClick={this.handleAddToCart}>Add all Selected to Cart</button>
                            </div>
                          </div>


                        </div>
                      </div>
                      :
                      <div className="row">
                        <div className="column small-12 medium-5">
                          {
                            !this.props.isFetching &&
                            <h1>{formatNumber(this.props.products.total)} {this.props.products.total === 1 ? 'result' : 'results'} for “{this.state.searchTerm}”</h1>
                          }
                        </div>
                        <div className="columns small-12 medium-7 text-right">
                          <div className="input-group-inline">
                            <div className="input-group">
                              <label className="input-group-label">Sort:</label>
                              <select className="input-group-field" onChange={this.handleSort} value={this.state.sort}>
                                <option value="relevance">Relevance</option>
                                <option value="price_asc">Price: Low to High</option>
                                <option value="price_desc">Price: High to Low</option>
                                <option value="name_asc">Name</option>
                              </select>
                            </div>
                          </div>

                          <div className="input-group-inline">
                            <div className="input-group search-results__header__per-page">
                              <span className="input-group-label">Display</span>
                              <select className="input-group-field" onChange={this.handlePerPageChange} value={this.state.perPage}>
                                <option value="10">10 per page</option>
                                <option value="20">20 per page</option>
                                <option value="50">50 per page</option>
                              </select>
                            </div>
                          </div>

                          <div className="clear-right"/>
                          <button className="button primary small products__button-add-all -no-margins"
                                  disabled={!Object.keys(this.state.quantities).length}
                                  onClick={this.handleAddToCart}>Add all Selected to Cart</button>
                        </div>
                      </div>
                  }
                </div>
                <div className="search-results__body">
                  <div className="row">
                    {
                      !!totalFilters &&
                      <div className="column small-12 medium-3">
                        <BrowseFilter filters={filters} filterValues={filterValues} onChange={this.handleFilterChange} isReadOnly={this.props.isFetching}/>
                      </div>
                    }
                    <div className={`column small-12 medium-${totalFilters ? 9 : 12} -no-padding`}>
                      {
                        <ProductsList products={products}
                                      onPageChange={this.handlePageChange}
                                      page={this.state.page}
                                      totalPages={Math.ceil(this.props.products.total / this.state.perPage)}
                                      onAddToMyProducts={this.handleAddToMyProducts}
                                      onRemoveFromMyProducts={this.handleRemoveFromMyProducts}
                                      onReset={this.handleReset}
                                      quantities={this.state.quantities}
                                      onQtyChange={this.handleQtyChange}
                                      onAddToCart={this.handleAddToCart}
                                      isFetching={this.props.isFetching} />
                      }
                    </div>
                  </div>
                </div>
              </div>
      </div>
    );
  }
}

AppProducts.propTypes = {
  searchTerms: PropTypes.string,
  catId: PropTypes.number,
  subCatId: PropTypes.number,
  brandId: PropTypes.number,
  actions: PropTypes.object.isRequired,
  products: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  printer: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  isFetchingFilters: PropTypes.bool.isRequired,
  titleOverride: PropTypes.string,
  isNonOemFirst: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isFetching: state.products.isFetching,
    isFetchingFilters: state.products.isFetchingFilters,
    products: state.products.products,
    printer: state.products.printer,
    filters: state.products.filters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
  actions: bindActionCreators(actions, dispatch)
};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppProducts);
